import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, watchEffect } from 'vue'
import moment from 'moment'
import WindRadarUI from '@/components/graph/WindRadar/WindRadarUI.vue'
import { useSummaryStore } from '@/stores/summaryStore'

type WindRadarProps = {
  stationId: string
  startTime: number
  endTime: number
  type: string
}

export default /*#__PURE__*/_defineComponent({
  props: {
    stationId: null,
    startTime: null,
    endTime: null,
    type: null
  },
  setup(__props: any) {

const props = __props as {
  stationId: string
  startTime: number
  endTime: number
  type: string
}



const summaryStore = useSummaryStore()

const values = computed(() => {
  const data = summaryStore.find(props.stationId)

  if (data === undefined || props.stationId === undefined) {
    return undefined
  }

  const results = data.items.moveWdMin10CountRate.last

  if (results === undefined) {
    return undefined
  }

  return Object.values(results)
})

watchEffect(() => {
  const { stationId, startTime, endTime, type } = props
  const range = {
    startTime: moment(startTime).format(),
    endTime: moment(endTime).format(),
  } as Range

  summaryStore.fetchWindCount(stationId, range, type)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(WindRadarUI, { values: _unref(values) }, null, 8, ["values"]))
}
}

})